import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import { renderField, renderTextarea } from '../../../utils/renderFields';
import { submitFeedback } from '../../../actions/globalConfig';

const propTypes = {
  removeModal: PropTypes.func,
};

const defaultProps = {
  removeModal: () => {},
  initialValues: {
    referer: '',
    browserInfo: '',
  },
};

class ErrorFeedbackForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    return this.props.dispatch(submitFeedback(values));
  }

  render() {
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;

    return (
      <div className="p-20" id="feedback-form-content">
        <form onSubmit={handleSubmit(this.submit)}>
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>

          {submitSucceeded && !submitting &&
            <div className="text-center">
              <p>Your error report has been submitted!</p>
              <div>
                <button
                  className="btn btn-dark"
                  onClick={(e) => {
                    window.location = window.location.origin;
                  }}
                >
                  Go to homepage
                </button>
              </div>
            </div>
          }

          {submitting && !submitSucceeded &&
            <div className="text-center">
              <p>Submitting feedback...</p>
            </div>
          }

          {!submitting && !submitSucceeded &&
            <div>
              <p>Fill out this form to submit an error report to our technical team.</p>
              <Field component={renderField} name="name" type="text" label="Name" className="form-control" />
              <Field component={renderField} name="email" type="email" label="Email" className="form-control" />
              <Field
                component={renderTextarea}
                name="body"
                type="textarea"
                label="Any details you'd like to provide along with the error report."
                className="form-control"
              />

              <Field component="input" type="hidden" name="referer" />
              <Field component="input" type="hidden" name="browser_info" />
              <Field component="input" type="hidden" name="error" />
              <Field component="input" type="hidden" name="subject" />

              <div className="d-flex justify-content-between">
                <div><input type="submit" value="Submit" id="submit" className="btn btn-primary" disabled={submitting} />
                </div>
              </div>
              <div className="text-center p-2">
                <button
                  className="btn btn-dark"
                  onClick={(e) => {
                    window.location = window.location.origin;
                  }}
                >Go to homepage
                </button>
              </div>
            </div>
          }

        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: () => {},
    initialValues: {
      referer: window.location.href,
      browser_info: window.navigator.userAgent,
      error: ownProps?.triggeringError?.stack || ownProps?.triggeringError?.message || '',
      subject: ownProps?.subject || 'Website Error Report',
    },
  };
};

ErrorFeedbackForm.propTypes = propTypes;
ErrorFeedbackForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(reduxForm({
  form: 'error-feedback',
  validate,
  fields: [
    'name',
    'email',
    'subject',
    'body',
  ],
})(ErrorFeedbackForm));
